import React, { useState, useEffect } from 'react'
import { Row, Col } from 'rsuite'
import { verificationOrganization } from '../../redux/actions/verification'
import { getValueFromOptions } from '../../utils/dataUtil'

export default function CompanyBasicInfoView({ data }) {
  const [organization, setOrganization] = useState(true)

  const companyNatureSelected = data?.companyNature?.optionSelected
  const organizationNatureSelected = organization?.masterOrganizationalBusinessTypeId
  const isOtherCompanyNatureSelected =
    companyNatureSelected == '13' || companyNatureSelected == '32'
  const isOtherOrganizationNatureSelected =
    organizationNatureSelected == '13' || organizationNatureSelected == '32'
  const companyNatureValue =
    (isOtherCompanyNatureSelected && data?.companyNature?.inputOther?.value) ||
    (isOtherOrganizationNatureSelected && organization?.otherOrganizationalBusinessType) ||
    data?.companyNature?.inputOther?.value ||
    getValueFromOptions(data?.companyNature?.options, companyNatureSelected) ||
    (organization &&
      (organization.otherOrganizationalBusinessType ||
        getValueFromOptions(data?.companyNature?.options, organizationNatureSelected))) ||
    'ไม่ระบุ'

  useEffect(() => {
    getOrganization()
  }, [])

  const getOrganization = async () => {
    if (data?.idNumber?.value) {
      try {
        let organization = await verificationOrganization(data?.idNumber?.value)
        // console.log('organization', organization)
        setOrganization(organization)
      } catch (e) {
        setOrganization('')
      }
    }
  }

  return (
    <Row>
      <Col xs={24} sm={24} md={24} lg={24}>
        &#9679; {data?.companyName?.value || organization?.organizationName || 'ไม่ระบุ'}
      </Col>
      {data?.subCompanyName && (
        <Col xs={24} sm={24} md={24} lg={24}>
          <span>
            &#9679; {`${data?.subCompanyName?.label} : `}
            <b>{data?.subCompanyName?.value || 'ไม่ระบุ'}</b>
          </span>
        </Col>
      )}

      {data?.companyType && (
        <Col xs={24} sm={24} md={24} lg={24}>
          <span>
            &#9679; {`${data?.companyType?.label} : `}
            <b>{`${
              getValueFromOptions(data?.companyType?.options, data?.companyType?.optionSelected) ||
              (organization &&
                getValueFromOptions(data?.companyType?.options, organization.organizationalType)) ||
              'ไม่ระบุ'
            }`}</b>
          </span>
        </Col>
      )}
      {data?.companyNature && (
        <Col xs={24} sm={24} md={24} lg={24}>
          <span>
            &#9679; {`${data?.companyNature?.label} : `}
            <b>{`${companyNatureValue}`}</b>
          </span>
        </Col>
      )}
      <Col xs={24} sm={12} md={8} lg={8}>
        <span>
          &#9679; {`${data?.idNumber?.label} : `}
          <b>{`${data?.idNumber?.value || 'ไม่ระบุ'}`}</b>
        </span>
      </Col>

      <Col xs={24} sm={12} md={8} lg={8}>
        <span>
          &#9679; {`${data?.telephone?.label} : `}
          <b>{`${data?.telephone?.value || 'ไม่ระบุ'}`}</b>
        </span>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <span>
          &#9679; {`${data?.mobile?.label} : `}
          <b>{`${data?.mobile?.value || 'ไม่ระบุ'}`}</b>
        </span>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <span>
          &#9679; {`${data?.fax?.label} : `}
          <b>{`${data?.fax?.value || 'ไม่ระบุ'}`}</b>
        </span>
      </Col>
      <Col xs={24} sm={12} md={8} lg={8}>
        <span>
          &#9679; {`${data?.email?.label} : `}
          <b>{`${data?.email?.value || 'ไม่ระบุ'}`}</b>
        </span>
      </Col>
    </Row>
  )
}
